module.exports = __webpack_public_path__ + "static/MainDevSecOps-ae2ff8dc6d5b5759b2f626f2abf16284.png";